import { FETCH_FORM_SUCCESS } from '@redux/modules/api/actionTypes';
import { RootActions } from 'types/state';
import { RootActionTypes } from '@redux/modules/actionTypes';
import cloneDeep from 'lodash/cloneDeep';
import * as ActionTypes from '../actionTypes';
import { fetchFormSuccessSlice } from '../slices/fetchForm';

export const populateCurrentAddress = (history2: any) => {
  const result = cloneDeep(history2);
  const items = (((result || {}).Residence || {}).List || {}).items || [];
  if (items.length === 0) {
    return result;
  }
  let found = false;
  for (const r of items) {
    if (!r.Item) {
      continue;
    }
    if (!r.Item.Address || !r.Item.Dates) {
      continue;
    }
    if (r.Item.Dates.present) {
      // We have an address with a present date
      result.CurrentAddress = { ...r.Item.Address };
      found = true;
    }
  }

  if (!found) {
    result.CurrentAddress = null;
  }
  return result;
};

const history = (state = {}, action: RootActions) => {
  switch (action.type) {
    case FETCH_FORM_SUCCESS:
      return fetchFormSuccessSlice(state, action, 'History');

    case ActionTypes.UPDATE_APP:
      if (action.section !== 'History') { return state; }
      const newState = {
        ...state,
        [action.property]: action.values,
      };

      if (action.property === 'Residence') {
        return {
          ...populateCurrentAddress(newState),
        };
      }

      return newState;

    case RootActionTypes.authentication.LOGGED_OFF: {
      return {};
    }

    default:
      return state;
  }
};


export default history;
